export type Listener<T> = (state: T) => void;

export class Store<T extends object> {
  private state: T;
  private listeners = new Set<Listener<T>>();

  constructor(initial: T) {
    this.state = initial;
  }

  get(): T {
    return this.state;
  }

  set(patch: Partial<T>): void {
    let changed = false;
    for (const k of Object.keys(patch) as Array<keyof T>) {
      const next = patch[k];
      if (next !== undefined && this.state[k] !== next) {
        this.state[k] = next as T[typeof k];
        changed = true;
      }
    }
    if (changed) {
      for (const fn of this.listeners) fn(this.state);
    }
  }

  subscribe(fn: Listener<T>): () => void {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }
}
